import React, { Component } from "react";
import {
  useLocation, // Embora não esteja sendo usado diretamente, mantive pela importação original
  useNavigate, // Embora não esteja sendo usado diretamente, mantive pela importação original
  NavLink, // Embora não esteja sendo usado diretamente, mantive pela importação original
  Outlet, // Embora não esteja sendo usado diretamente, mantive pela importação original
  Navigate, // Embora não esteja sendo usado diretamente, mantive pela importação original
  Link,
} from "react-router-dom";
import CardProduct from "../../comps/CardProdct";
import withRouter from "../../withRouter"; // Certifique-se de que 'withRouter' está configurado corretamente para injetar params
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowLeft, faArrowRight } from "@fortawesome/free-solid-svg-icons";

class Pesquisa extends Component {
  constructor(props) {
    super(props);
    this.state = {
      parametro: "",
      data: [], // Contém todos os dados brutos da API
      load: true,
      erro: false,
      categorias: [],
      marcas: [],
      currentPage: 1, // Página atual
      productsPerPage: 100, // Produtos por página
      totalProducts: 0, // Total de produtos encontrados
    };
  }

  // handleClick não parece ser usado no contexto atual de navegação por busca
  // handleClick(placeToGo) {
  //   this.props.history.push(`/busca/` + placeToGo);
  // }

  LoadReasut = (url, page = 1) => {
    this.setState({ load: true, currentPage: page, erro: false, data: [] }); // Resetar erro e data ao carregar

    fetch(`${this.props.host}/_next/api/pesquisa?p=${url}`)
      .then((response) => {
        if (!response.ok) {
          throw new Error("Network response was not ok " + response.statusText);
        }
        return response.json();
      })
      .then((data) => {
        if (data.estado === "erro" || !data[0] || !data[0].data) {
          this.setState({
            erro: true,
            load: false,
            data: [],
            totalProducts: 0,
          });
        } else {
          const allProducts = data[0].data; // Dados brutos da API

          const uniqueCategories = new Map();
          const uniqueBrands = new Map();

          allProducts.forEach((product) => {
            if (
              product.categoria &&
              product.categoria.titulo &&
              product.categoria.link
            ) {
              uniqueCategories.set(product.categoria.link, {
                titulo: product.categoria.titulo,
                link: product.categoria.link,
              });
            }
            if (product.marca && product.marca.titulo && product.marca.link) {
              // Assumindo que a marca também tem um link, ou usará o título para o link
              uniqueBrands.set(product.marca.link, {
                titulo: product.marca.titulo,
                link: product.marca.link,
              });
            }
          });

          this.setState({
            data: data, // Armazena o objeto de resposta completo (incluindo 'vqd' se presente)
            load: false,
            erro: false,
            categorias: Array.from(uniqueCategories.values()),
            marcas: Array.from(uniqueBrands.values()),
            totalProducts: allProducts.length, // O total de produtos antes da paginação
          });
        }
      })
      .catch((error) => {
        console.error("Erro na requisição da pesquisa:", error);
        this.setState({ erro: true, load: false, data: [], totalProducts: 0 });
      });
  };

  // Método para mudar a página
  paginate = (pageNumber) => {
    // Ao mudar a página, queremos manter o filtro de busca atual
    // A função LoadReasut já não precisa carregar os dados novamente, apenas atualizar o estado
    this.setState({ currentPage: pageNumber });
    // Scroll para o topo da seção de produtos para melhor UX
    const productSection = document.getElementById("pdts");
    if (productSection) {
      productSection.scrollIntoView({ behavior: "smooth" });
    }
  };

  componentDidUpdate(prevProps) {
    // Carrega novos resultados se o parâmetro da URL de busca mudar
    if (prevProps.params.id !== this.props.params.id) {
      const parametro = this.props.params.id; // Pegar o ID do path params
      this.LoadReasut(parametro, 1); // Resetar para a primeira página em uma nova busca
    }
  }

  componentDidMount() {
    console.log("Props no componentDidMount:", this.props);
    const parametro = this.props.params.id; // Pegar o ID do path params
    this.LoadReasut(parametro, 1); // Carregar a primeira página ao montar
  }

  render() {
    const {
      data,
      load,
      erro,
      categorias,
      marcas,
      currentPage,
      productsPerPage,
      totalProducts,
    } = this.state;

    // Lógica de Paginação
    const allProductsInResult = data[0]?.data || []; // Se data[0] não existe ou data[0].data não existe, retorna um array vazio
    const indexOfLastProduct = currentPage * productsPerPage;
    const indexOfFirstProduct = indexOfLastProduct - productsPerPage;
    const currentProducts = allProductsInResult.slice(
      indexOfFirstProduct,
      indexOfLastProduct
    );

    // Calcular números de página
    const pageNumbers = [];
    if (totalProducts > 0) {
      for (let i = 1; i <= Math.ceil(totalProducts / productsPerPage); i++) {
        pageNumbers.push(i);
      }
    }

    if (load === true) {
      return (
        <>
          <section className="product-grids section">
            <div className="container">
              <div className="row">
                <div className="col-lg-3 col-12">
                  <div className="product-sidebar">
                    <div id="listCtg" className="single-widget">
                      <h3>
                        <div
                          className="load"
                          style={{ width: "100%", height: 14 }}
                        ></div>
                      </h3>
                      <ul className="list" id="listCtg">
                        <li>
                          <div
                            className="load"
                            style={{ width: "100%", height: 14 }}
                          ></div>
                        </li>
                        <li>
                          <div
                            className="load"
                            style={{ width: "100%", height: 14 }}
                          ></div>
                        </li>
                        <li>
                          <div
                            className="load"
                            style={{ width: "100%", height: 14 }}
                          ></div>
                        </li>
                        <li>
                          <div
                            className="load"
                            style={{ width: "100%", height: 14 }}
                          ></div>
                        </li>
                      </ul>
                    </div>

                    <div className="single-widget range">
                      <h3>
                        <div
                          className="load"
                          style={{ width: "100%", height: 14 }}
                        ></div>
                      </h3>
                      <div
                        className="load"
                        style={{ width: "100%", height: 14 }}
                      ></div>
                      <div className="range-inner"></div>
                    </div>
                  </div>
                </div>
                <div className="col-lg-9 col-12">
                  <div className="product-grids-head">
                    <div className="product-grid-topbar">
                      <div className="row align-items-center">
                        <div className="col-lg-7 col-md-8 col-12">
                          <div className="product-sorting">
                            <h3 className="total-show-product">
                              <div
                                className="load"
                                style={{ width: 250, height: 14, top: 3 }}
                              ></div>
                            </h3>
                          </div>
                        </div>
                        <div className="col-lg-5 col-md-4 col-12">
                          <nav></nav>
                        </div>
                      </div>
                    </div>
                    <div className="tab-content" id="nav-tabContent">
                      <div
                        className="tab-pane fade show active"
                        id="nav-grid"
                        role="tabpanel"
                        aria-labelledby="nav-grid-tab"
                      >
                        <div className="row" id="pdts">
                          {[...Array(productsPerPage)].map(
                            (
                              _,
                              index // Renderiza placeholders igual ao num de produtos por página
                            ) => (
                              <div
                                className="col-lg-4 col-md-6 col-12"
                                key={index}
                              >
                                <div className="load single-product"></div>
                              </div>
                            )
                          )}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </section>
        </>
      );
    } else {
      if (erro === true) {
        return (
          <>
            <div className="error-area">
              <div className="d-table">
                <div className="ajusta">
                  <div className="container">
                    <div className="error-content">
                      <img
                        className="ErrImg"
                        src={this.props.host + "/_next/static/imagens/nada.svg"}
                        alt="Nenhum resultado encontrado"
                      />
                      <h2>Nenhum resultado foi encontrado</h2>
                      <p>
                        Tente usar palavras-chave diferentes ou mais genéricas
                      </p>
                      <div className="button">
                        <Link to="/" className="btn">
                          Página inicial
                        </Link>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </>
        );
      } else {
        return (
          <>
            <section className="product-grids section">
              <div className="container">
                <div className="row">
                  <div className="col-lg-3 col-12">
                    <div className="product-sidebar">
                      <div id="listCtg" className="single-widget">
                        <h3>Todas categorias</h3>
                        <ul className="list" id="listCtg">
                          {categorias.map((item, index) => (
                            <li key={index}>
                              <Link to={`/categoria/${item.link}`}>
                                {item.titulo}
                              </Link>
                            </li>
                          ))}
                        </ul>
                      </div>

                      {marcas.length > 0 && (
                        <div id="listCtg" className="single-widget">
                          <h3>Marcas</h3>
                          <ul className="list" id="listCtg">
                            {marcas.map((item, index) => (
                              <li key={index}>
                                <Link to={`/marca/${item.link}`}>
                                  {item.titulo}
                                </Link>
                              </li>
                            ))}
                          </ul>
                        </div>
                      )}

                      <div className="single-widget range">
                        <h3>Faixa de preço até:</h3>
                        <div className="range-inner">
                          <label>R$</label>
                          {/* Você pode adicionar um input ou slider aqui para o filtro de preço */}
                        </div>
                      </div>
                    </div>
                  </div>

                  <div className="col-lg-9 col-12">
                    <div className="product-grids-head">
                      {data[0]?.hasOwnProperty("vqd") ? (
                        <div className="product-grid-topbar">
                          <div className="row align-items-center">
                            <div className="col-lg-7 col-md-8 col-12">
                              <div className="product-sorting">
                                <h3 className="total-show-product">
                                  Você quis dizer:{" "}
                                  <Link
                                    to={`/busca/${data[0].vqd}`}
                                    className="active"
                                    aria-label="Toggle navigation"
                                  >
                                    {data[0].vqd}
                                  </Link>
                                </h3>
                              </div>
                            </div>
                          </div>
                        </div>
                      ) : (
                        <div className="product-grid-topbar">
                          <div className="row align-items-center">
                            <div className="col-lg-7 col-md-8 col-12">
                              <div className="product-sorting">
                                <h3 className="total-show-product">
                                  Resultados encontrados:{" "}
                                  <span>{totalProducts}</span>
                                </h3>
                              </div>
                            </div>
                            <div className="col-lg-5 col-md-4 col-12">
                              <nav></nav>
                            </div>
                          </div>
                        </div>
                      )}

                      <div className="tab-content" id="nav-tabContent">
                        <div
                          className="tab-pane fade show active"
                          id="nav-grid"
                          role="tabpanel"
                          aria-labelledby="nav-grid-tab"
                        >
                          {" "}
                          {totalProducts > productsPerPage && (
                            <div className="d-flex justify-content-center mt-4">
                              <ul className="pagination-list">
                                {/* Botão "Anterior" */}
                                <li
                                  className={`page-item ${
                                    currentPage === 1 ? "disabled" : ""
                                  }`}
                                  onClick={() =>
                                    currentPage > 1 &&
                                    this.paginate(currentPage - 1)
                                  }
                                >
                                  <a href="#!" className="page-link">
                                    <FontAwesomeIcon icon={faArrowLeft} />{" "}
                                    Anterior
                                  </a>
                                </li>

                                {pageNumbers.map((number) => (
                                  <li
                                    key={number}
                                    className={`page-item ${
                                      currentPage === number ? "active" : ""
                                    }`}
                                  >
                                    <a
                                      onClick={() => this.paginate(number)}
                                      href="#!"
                                      className="page-link"
                                    >
                                      {number}
                                    </a>
                                  </li>
                                ))}

                                {/* Botão "Próximo" */}
                                <li
                                  className={`page-item ${
                                    currentPage === pageNumbers.length
                                      ? "disabled"
                                      : ""
                                  }`}
                                  onClick={() =>
                                    currentPage < pageNumbers.length &&
                                    this.paginate(currentPage + 1)
                                  }
                                >
                                  <a href="#!" className="page-link">
                                    Próximo{" "}
                                    <FontAwesomeIcon icon={faArrowRight} />
                                  </a>
                                </li>
                              </ul>
                            </div>
                          )}
                          <div className="row" id="pdts">
                            {currentProducts.length > 0 ? (
                              <CardProduct
                                itens={currentProducts} // Passa apenas os produtos da página atual
                                list={4} // Número de colunas para produtos no grid
                                host={this.props.host}
                              />
                            ) : (
                              <div className="col-12 text-center py-5">
                                <h3>Nenhum produto encontrado nesta página.</h3>
                              </div>
                            )}
                          </div>
                          {/* Controles de Paginação */}
                          {totalProducts > productsPerPage && (
                            <div className="d-flex justify-content-center mt-4">
                              <ul className="pagination-list">
                                {/* Botão "Anterior" */}
                                <li
                                  className={`page-item ${
                                    currentPage === 1 ? "disabled" : ""
                                  }`}
                                  onClick={() =>
                                    currentPage > 1 &&
                                    this.paginate(currentPage - 1)
                                  }
                                >
                                  <a href="#!" className="page-link">
                                    <FontAwesomeIcon icon={faArrowLeft} />{" "}
                                    Anterior
                                  </a>
                                </li>

                                {pageNumbers.map((number) => (
                                  <li
                                    key={number}
                                    className={`page-item ${
                                      currentPage === number ? "active" : ""
                                    }`}
                                  >
                                    <a
                                      onClick={() => this.paginate(number)}
                                      href="#!"
                                      className="page-link"
                                    >
                                      {number}
                                    </a>
                                  </li>
                                ))}

                                {/* Botão "Próximo" */}
                                <li
                                  className={`page-item ${
                                    currentPage === pageNumbers.length
                                      ? "disabled"
                                      : ""
                                  }`}
                                  onClick={() =>
                                    currentPage < pageNumbers.length &&
                                    this.paginate(currentPage + 1)
                                  }
                                >
                                  <a href="#!" className="page-link">
                                    Próximo{" "}
                                    <FontAwesomeIcon icon={faArrowRight} />
                                  </a>
                                </li>
                              </ul>
                            </div>
                          )}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </section>
          </>
        );
      }
    }
  }
}
export default withRouter(Pesquisa);
